const nav = document.getElementById('nav');
const ho = document.getElementById('hero-outer');

function setNavOffset() {
  const navOffset = ho ? 0 : (nav ? nav.offsetHeight : 0);
  document.documentElement.style.setProperty('--nav-offset', navOffset + 'px');
}

setNavOffset();
window.addEventListener('resize', setNavOffset, { passive: true });
window.addEventListener('load', setNavOffset);
if (nav && typeof ResizeObserver !== 'undefined') {
  const navResizeObserver = new ResizeObserver(setNavOffset);
  navResizeObserver.observe(nav);
}

/* ── VIDEO SCRUB (homepage only) ───────────────────────── */
const vid = document.getElementById('hero-video');
const sf  = document.getElementById('sf');

if (vid && sf && ho) {
  vid.pause();
  vid.currentTime = 0;
  vid.addEventListener('canplay', function() {
    vid.style.opacity = '1';
  });

  function onScroll() {
    const r   = ho.getBoundingClientRect();
    const tot = ho.offsetHeight - window.innerHeight;
    const p   = Math.min(1, Math.max(0, -r.top) / tot);
    sf.style.width = (p * 100) + '%';
    if (vid.readyState >= 2 && vid.duration) {
      vid.currentTime = p * vid.duration;
    }
    if (nav) {
      nav.classList.toggle('up', ho.getBoundingClientRect().bottom <= 60);
    }
  }

  if (window.innerWidth > 768) {
    window.addEventListener('scroll', function() { onScroll(); }, { passive: true });
  }
}

/* ── UNIVERSAL NAV COLOUR (all other pages) ─────────────── */
// On pages without the video hero, watch for any element with
// data-nav="dark" (dark background sections). While one is
// intersecting the top of the viewport, keep nav transparent
// (white text). Once they all scroll away, apply nav.up (navy text).
if (!ho) {
  var darkSections = document.querySelectorAll('[data-nav="dark"]');

  if (darkSections.length > 0) {
    var darkVisible = new Set();

    var navObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          darkVisible.add(entry.target);
        } else {
          darkVisible.delete(entry.target);
        }
        if (nav) {
          nav.classList.toggle('up', darkVisible.size === 0);
        }
      });
    }, {
      threshold: 0,
      rootMargin: '-64px 0px 0px 0px'
    });

    darkSections.forEach(function(el) { navObs.observe(el); });
  } else {
    if (nav) {
      nav.classList.add('up');
    }
  }
}

/* ── REVEAL ─────────────────────────────────────────────── */
const io = new IntersectionObserver(function(es) {
  es.forEach(function(e) {
    if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
  });
}, { threshold: 0.1 });
document.querySelectorAll('.rv').forEach(function(el) { io.observe(el); });

/* ── EMAIL ──────────────────────────────────────────────── */
function sub() {
  const i = document.getElementById('e');
  if (!i.value.trim().includes('@')) { i.style.borderColor = 'rgba(255,80,80,0.4)'; setTimeout(() => i.style.borderColor = '', 1800); return; }
  const b = document.querySelector('#final .e-row button');
  b.textContent = 'Reserved ✓'; b.style.opacity = '0.7';
  i.value = ''; i.placeholder = "You're on the list."; i.disabled = true; b.disabled = true;
}
function sub2() {
  const i = document.getElementById('e2');
  if (!i.value.trim().includes('@')) { i.style.borderColor = 'rgba(255,80,80,0.4)'; setTimeout(() => i.style.borderColor = '', 1800); return; }
  const b = i.nextElementSibling;
  b.textContent = 'Reserved ✓'; b.style.opacity = '0.7';
  i.value = ''; i.placeholder = "You're on the list."; i.disabled = true; b.disabled = true;
}
